// Publicado nesta sessão: o gate do painel não leva de volta ao wizard enquanto o
// /dashboard/info ainda vier de um cache anterior à publicação (evita o vai e volta).
const flagKey = (customer: string) => `kfy-onboarding-published:${customer}`;

export function markOnboardingPublished(customer: string) {
  try {
    window.sessionStorage.setItem(flagKey(customer), '1');
  } catch {
    // sessionStorage indisponível (aba privada, bloqueio): o gate segue o /dashboard/info
  }
}

export function isOnboardingPublishedLocally(customer: string) {
  try {
    return window.sessionStorage.getItem(flagKey(customer)) === '1';
  } catch {
    return false;
  }
}
